import { jsx as _jsx } from "react/jsx-runtime";
import { useForm, FormProvider } from 'react-hook-form';
import BaseDialog from '../Dialog/Dialog';
export default function FormDialog(props) {
    const { title, open, onClose, okButtonText = 'Ok', onSubmit, children, okButtonColorType, cancelButtonColorType = 'primary', disabledOkButton = false, } = props;
    const methods = useForm();
    const closeDialog = () => {
        onClose(false);
        methods.reset();
    };
    const submitHandler = args => {
        closeDialog();
        onSubmit(args);
    };
    const buttons = [
        {
            children: okButtonText,
            onClick: methods.handleSubmit(submitHandler),
            color: okButtonColorType,
            disabled: disabledOkButton,
        },
        { children: 'Cancel', onClick: closeDialog, color: cancelButtonColorType },
    ];
    return (_jsx(FormProvider, Object.assign({}, methods, { children: _jsx(BaseDialog, { open: open, title: title, buttons: buttons, onClose: closeDialog, children: children }) })));
}
